module.exports = __webpack_public_path__ + "static/media/plato-3@2x.4932e731.png";